import { render, staticRenderFns } from "./CircularWave.vue?vue&type=template&id=d3940194&scoped=true&"
import script from "./CircularWave.vue?vue&type=script&lang=js&"
export * from "./CircularWave.vue?vue&type=script&lang=js&"
import style0 from "./CircularWave.vue?vue&type=style&index=0&id=d3940194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3940194",
  null
  
)

export default component.exports